import React from "react";
import ChartSidebarAccordion from "../ChartSidebarAccordion";
import { useSelector } from "react-redux";
import ColoradoRiverAccessLocationFilter from "../ColoradoRiverAccessLocationFilter";
import { Typography, Grid } from "@material-ui/core";
import useStyles from "../Styles";
import userActions from "../actions";
import { useHistory } from "react-router";

function ColoradoRiverMetrics({ metrics }) {
  const classes = useStyles();
  return (
    <Grid
      container
      direction="row"
      spacing={1}
      className={classes.metricsContainer}
    >
      {metrics.map((metric, idx) => (
        <React.Fragment key={`${metric.label}_${idx}`}>
          <Grid item align="right" sm={4}>
            <Typography
              variant="body2"
              component="p"
              className={classes.gaugeMetricTitle}
              display="inline"
            >
              {metric.label}
            </Typography>
          </Grid>
          <Grid item align="right" sm={8} style={{ paddingRight: "20px" }}>
            <Typography
              variant="h6"
              component="div"
              className={classes.gaugeMetricValue}
              display="inline"
            >
              {metric.value}
            </Typography>
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
}

function GaugePieChartTab() {
  const { entity_entitlements, cities, city_selected, scenario_selected } = useSelector((state) => state.technical_view);
  const {
    setSelectedCity,
    loadEntityEntitlements,
    loadCityMetrics,
    setIsTribe,
    setIsWesternEntity,
  } = userActions();

  const history = useHistory()

  const classes = useStyles();

  const start_year = 2023;
  const end_year = 2060;

  const metrics = Object.keys(Object.fromEntries(Object.entries(entity_entitlements).filter(([key]) => (key>=start_year && key<=end_year)))).map((year) => {
    return {
      label: year,
      value: `${Math.round(
        entity_entitlements[year]["total_co_access"]
      ).toLocaleString("en-US")} ac-ft available`,
    };
  });

  const handleChange = (value) => {
    loadCityMetrics(value);
    var cityFound = cities.find((item) => item.value === (value));
    setSelectedCity(cityFound);
    loadEntityEntitlements(value, scenario_selected.value);
    setIsTribe(false);
    setIsWesternEntity(false);

    history.push({
      pathname: `/visualizations/gauge`,
      search:  "?" + new URLSearchParams({type: "cities", dropdown: cityFound?.label}).toString()
    });
  }

  return (
    <>
      <ColoradoRiverAccessLocationFilter
          location_options={cities}
          handleChange={handleChange}
          city_id={city_selected.city_id}
          style={{ marginLeft: 26 }}
          autocomplete={true}
        />
        <Typography
        variant="body2"
        component="div"
        className={classes.metricSubTitle}
        >
        </Typography>
        <ChartSidebarAccordion group_name={`Colorado River availability per year`} accordion_name={'availability'}>
          <ColoradoRiverMetrics metrics={metrics} />
        </ChartSidebarAccordion>
    </>
    
  );
}

export default GaugePieChartTab;
